import { doc, getDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { getFirestoreDb } from '@/lib/firebase';

export function usePartyNames(
  orgId: string | null,
  type: 'customers' | 'vendors',
  ids: string[]
) {
  const [names, setNames] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    if (!orgId || !ids.length) {
      setNames(new Map());
      return;
    }
    const unique = [...new Set(ids.filter(Boolean))];
    let cancelled = false;
    void (async () => {
      const entries = await Promise.all(
        unique.map(async (id) => {
          const snap = await getDoc(
            doc(getFirestoreDb(), 'organizations', orgId, type, id)
          );
          return [id, String(snap.data()?.name ?? '')] as const;
        })
      );
      if (!cancelled) setNames(new Map(entries));
    })();
    return () => {
      cancelled = true;
    };
  }, [orgId, type, ids.join(',')]);

  return names;
}
